import React from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ButtonBase from '@material-ui/core/ButtonBase';

import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import pink from '@material-ui/core/colors/pink';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faThumbsUp,
  faThumbsDown,
  faGrinHearts
} from '@fortawesome/free-solid-svg-icons';

import Avatar from '../../components/Avatar';

import { actions } from '../../services/userProfile';
import { Typography } from '@material-ui/core';

const styled = withStyles(theme => {
  return {
    container: {
      overflowX: 'auto'
    },
    table: {
      // maxWidth: 600,
      margin: '0px auto'
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    timeAgo: {
      whiteSpace: 'nowrap'
    }
  };
});

class TabSwipes extends React.Component {
  renderRow(swipe) {
    let _icon;
    let _color = '#000';
    if (swipe.type === 'dislike') {
      _icon = faThumbsDown;
      _color = red[500];
    } else if (swipe.type === 'like') {
      _icon = faThumbsUp;
      _color = green[500];
    } else if (swipe.type === 'super_like') {
      _icon = faGrinHearts;
      _color = pink[500];
    }

    const icon = <FontAwesomeIcon icon={_icon} size="3x" color={_color} />;

    return (
      <TableRow key={swipe._id}>
        <TableCell align="center">{icon}</TableCell>
        <TableCell className={this.props.classes.timeAgo} align="center">
          {moment(new Date(swipe.createTime).toUTCString()).fromNow()}
        </TableCell>
        <TableCell align="center">
          <ButtonBase component={Link} to={`/users/${swipe.targetUser._id}`}>
            <Avatar user={swipe.targetUser} size={60} />
          </ButtonBase>
          <Typography>{swipe.targetUser.firstName}</Typography>
        </TableCell>
      </TableRow>
    );
  }

  renderNoData() {
    return (
      <TableRow>
        <TableCell align="center">No Swipes</TableCell>
      </TableRow>
    );
  }

  componentDidMount() {
    const { data } = this.props;
    if (data.swipes) {
      return;
    }
    this.props.actions.load();
  }

  render() {
    const { data, classes } = this.props;
    if (!data.swipes) {
      return (
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <div className={classes.container}>
        <Table className={classes.table}>
          <TableBody>
            {data.swipes.length > 0
              ? data.swipes.map(item => this.renderRow(item))
              : this.renderNoData()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.userProfile.data
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    load: () => dispatch(actions.loadSwipes())
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(TabSwipes))
);
